module.exports = __webpack_public_path__ + "img/no_lb.9b0cbc90.png";